import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Notification from 'components/ui/base/notification/Notification';
import useGlobalOverlay from 'hooks/useGlobalOverlay';
import { duplicateInvoice } from 'store/invoices/client';
import { getErrorMessage } from 'utils/getErrorMessage';

const useDuplicateInvoice = () => {
    const navigate = useNavigate();
    const { showGlobalOverlay, hideGlobalOverlay } = useGlobalOverlay();

    const handleDuplicateInvoice = useCallback(
        async (invoiceId: string) => {
            try {
                showGlobalOverlay({
                    type: 'LoadingOverlay',
                    payload: {
                        message: 'Duplicating invoice',
                    },
                });

                const duplicate = await duplicateInvoice(invoiceId);

                Notification({
                    type: 'success',
                    description: 'Invoice duplicated successfully',
                    messageTitle: 'Success',
                    placement: 'top',
                });

                navigate(`/invoices/${duplicate.id}`);
                return duplicate;
            } catch (err) {
                const errorMessage = getErrorMessage(err);
                Notification({
                    type: 'error',
                    description: errorMessage ?? 'Failed to duplicate the invoice',
                    messageTitle: 'Error',
                    placement: 'top',
                });
                throw err;
            } finally {
                hideGlobalOverlay();
            }
        },
        [navigate, showGlobalOverlay, hideGlobalOverlay]
    );

    return { duplicateInvoice: handleDuplicateInvoice };
};

export default useDuplicateInvoice;
